import {asset} from 'imba';
import url from './mobile2.png';
export default asset({
	url: url,
	type: 'image',
	width: 1204,
	height: 853,
	toString: function(){ return this.url;}
})